import { render, staticRenderFns } from "./AppYarmarka.vue?vue&type=template&id=325f8262&scoped=true"
import script from "./AppYarmarka.vue?vue&type=script&lang=ts"
export * from "./AppYarmarka.vue?vue&type=script&lang=ts"
import style0 from "./AppYarmarka.vue?vue&type=style&index=0&id=325f8262&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f8262",
  null
  
)

export default component.exports